











	// @ts-ignore
    import _ from './Typing.ts'; export default _;
